import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import { useDispatch, useSelector } from "react-redux";
import AllNotification from "./AllNotification";
import MyNotifications from "./MyNotifications";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";

const tabs = [
  { label: "pushNotifications", value: "notification" },
  { label: "yourNotifications", value: "mynotification" },
];

function AdminNotification() {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (valuee) => {
    dispatch(setActiveTab({ ...activeTab, notification: valuee }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"notifications"}
            tabs={tabs}
            activeTab={activeTab.notification}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.notification === "notification" ? (
            <AllNotification />
          ) : null}
          {activeTab.notification === "mynotification" ? (
            <MyNotifications />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default AdminNotification;
